export enum MenuType {
  NORMAL = 'NORMAL',
  FORM = 'FORM',
}

export const MenuTypeMap = {
  [MenuType.NORMAL]: '普通菜单',
  [MenuType.FORM]: '表单菜单',
};
